/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awful_Solid_Gadfly_ThriveInputs */

const fr_awful_solid_gadfly_thrive = /** @type {(inputs: Awful_Solid_Gadfly_ThriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère ton profil ici.`)
};

/**

* @param {Awful_Solid_Gadfly_ThriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awful_solid_gadfly_thrive = /** @type {((inputs?: Awful_Solid_Gadfly_ThriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awful_Solid_Gadfly_ThriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awful_solid_gadfly_thrive(inputs)
});